webpackJsonp([280608832874753],{

/***/ 404:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{}}

/***/ })

});


// WEBPACK FOOTER //
// path---brand-design-birth-a0e39f21c11f6a62c5ab.js